<template>
  <div class="submitted-preview d-flex justify-center">
    <phone-frame>
      <!-- Header Bar -->
      <div class="header-bar">
        <div class="d-flex align-center">
          <div class="clinic-icon mr-2">🦷</div>
          <span class="white--text text-body-2">{{ mockData.clinicName }}</span>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="content-area">
        <!-- Decorative Background -->
        <div class="decorative-bg">
          <span class="x-mark">✕</span>
          <span class="x-mark">✕</span>
          <span class="x-mark">✕</span>
        </div>

        <!-- Heart Icon -->
        <div class="heart-icon-wrapper">
          <div class="heart-icon">
            <span class="heart">❤️</span>
            <div class="x-badge">✕</div>
          </div>
        </div>

        <!-- Info Card -->
        <v-card class="info-card" elevation="2" rounded="lg">
          <!-- Title -->
          <div class="text-center pt-6 pb-4">
            <div class="text-h6 font-weight-medium">{{ mockData.clinicName }}</div>
            <div class="text-h6 font-weight-medium">【約診已取消】</div>
          </div>

          <!-- Info Rows -->
          <div class="px-6">
            <div class="info-row mb-2">
              <span class="info-label">◼️ 預約時間：</span>
              <div class="info-value">
                <div>{{ formattedDateShort }}</div>
                <div>{{ mockData.appointmentTime }}</div>
              </div>
            </div>

            <div class="info-row mb-2">
              <span class="info-label">◼️ 診所地址：</span>
              <div class="info-value">
                <div>{{ addressLine1 }}</div>
                <div>{{ addressLine2 }}</div>
              </div>
            </div>

            <div class="info-row mb-2">
              <span class="info-label">◼️ 預約醫師：</span>
              <span class="info-value">{{ mockData.doctorName }}醫師</span>
            </div>

            <div class="info-row mb-4">
              <span class="info-label">◼️ 預約人：</span>
              <span class="info-value">{{ mockData.patientName }}</span>
            </div>

            <v-divider class="mb-4" />

            <div class="info-row mb-2">
              <span class="info-label">◼️ 改約原因：</span>
              <span class="info-value">{{ selectedReason }}</span>
            </div>

            <div class="info-row mb-4">
              <span class="info-label">◼️ 是否需聯繫：</span>
              <span class="info-value">{{ selectedContact }}</span>
            </div>
          </div>

          <!-- Warning Box -->
          <v-alert
            border="left"
            colored-border
            dense
            color="#FF6B6B"
            class="mx-6 mb-6 warning-box"
            :icon="false"
          >
            <div class="d-flex align-start">
              <span class="mr-2">⚠️</span>
              <span class="text-body-2">為保留您下次預約的權益，建議您主動聯繫診所。</span>
            </div>
          </v-alert>

          <!-- Buttons -->
          <div class="px-6 pb-6">
            <v-btn block dark large class="mb-3 rounded-lg" color="black">致電聯繫</v-btn>
            <v-btn block outlined large class="rounded-lg" color="grey">確認關閉</v-btn>
          </div>
        </v-card>
      </div>
    </phone-frame>
  </div>
</template>

<script>
import PhoneFrame from './PhoneFrame.vue'

export default {
  name: 'SubmittedPreview',

  components: {
    PhoneFrame
  },

  props: {
    mockData: {
      type: Object,
      default: () => ({})
    },
    selectedReason: {
      type: String,
      default: ''
    },
    selectedContact: {
      type: String,
      default: ''
    }
  },

  computed: {
    formattedDateShort() {
      const date = this.mockData.appointmentDate || ''
      const weekday = this.mockData.appointmentWeekday || ''
      // 轉換格式：2026/01/20 -> 2026-01-20 (一)
      if (date) {
        const formatted = date.replace(/\//g, '-')
        return `${formatted} (${weekday})`
      }
      return date
    },
    addressLine1() {
      const address = this.mockData.clinicAddress || ''
      // 簡單切分地址為兩行
      if (address.length > 10) {
        return address.substring(0, 10)
      }
      return address
    },
    addressLine2() {
      const address = this.mockData.clinicAddress || ''
      if (address.length > 10) {
        return address.substring(10)
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.submitted-preview {
  width: 100%;
  max-width: 360px;
}

.header-bar {
  background: #4A4A4A;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clinic-icon {
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.content-area {
  flex: 1;
  background: #E5E5E5;
  position: relative;
  padding: 16px;
}

.decorative-bg {
  position: absolute;
  top: 16px;
  left: 16px;
  right: 16px;
  height: 100px;
  background: linear-gradient(180deg, rgba(209, 213, 220, 0.3) 0%, rgba(0, 0, 0, 0) 100%);
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  padding-top: 12px;
  opacity: 0.5;

  .x-mark {
    font-size: 32px;
    color: #C0C0C0;
  }
}

.heart-icon-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  padding-top: 24px;
}

.heart-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(180deg, #FF6B87 0%, #FF4D6D 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  .heart {
    font-size: 28px;
  }

  .x-badge {
    position: absolute;
    right: -4px;
    bottom: -4px;
    width: 32px;
    height: 32px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: #FF4D6D;
    box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.1), 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
}

.info-card {
  position: relative;
  z-index: 1;
}

.info-row {
  display: flex;
  font-size: 13px;
  line-height: 1.5;

  .info-label {
    color: #666;
    width: 110px;
    flex-shrink: 0;
  }

  .info-value {
    color: #333;
  }
}

.warning-box {
  background-color: #FFF5F5 !important;

  ::v-deep .v-alert__content {
    color: #FF6B6B;
  }
}

</style>
